export default __webpack_public_path__ + "static/media/02_DAIF_Services_03.27ac47f6.mp4";